import styled from 'styled-components';
import { Table } from '../../ui/Table';


export const TableFrame = styled.div`
    
    ${Table} {
        border-left: none;
        border-right: none;

        & td:first-child {
            padding-left: 2rem;
        }

        & td:last-child {
            padding-right: 2rem;
        }
    }
`;
